<div class="view-invoice-main-form">
  <es-details-invoice-card-form-desktop
    [fg]="fg"
    [billOfLadingId]="billOfLadingId"
    [currencies]="currencies"
    [currencyRate]="currencyRate"
    [incoterms]="incoterms"
  ></es-details-invoice-card-form-desktop>

  <es-details-entity-desktop
    icon="assets/icons/manufacturer.svg"
    [title]="'MANUFACTURER' | translate"
    [subTitle]="'INFO.MF.SUB_TITLE_DESKTOP' | translate"
    [subTitleHint]="'LABELS.USE_SELLER_INVOICE' | translate"
    [isShowEdit]="true"
    [entity]="manufacturerEntity"
    (edit)="editMF.emit()"
  ></es-details-entity-desktop>

  <div class="w-100 text-center">
    <button type="button" class="btn view-invoice-footer-button view-invoice-main-form-button-outline ml-1" (click)="saveInvoice.emit()">
      {{ "BUTTON.SAVE" | translate }}
    </button>
  </div>
</div>
